'use strict';

angular.module('far.discipline')
    .controller('DisciplineNewsController', function($log, $http) {
        var vm = {
            loaded: true,
            submitted: false,
            params: {
                limit: 10,
                offset: 0,
                discipline: null
            },
            total: {
                count: 0,
                pages: null
            },
            data: [],
            construct: function ( discipline ) {
                vm.params.discipline = discipline;

                vm.submit();
            },
            submit: function ( next ) {
                if (vm.submitted) {
                    return false;
                }

                if ( !next ) {
                    vm.params.offset = 0;

                    vm.total.count = 0;
                    vm.total.pages = null;

                    vm.data = [];
                }

                vm.submitted = true;

                $http.get(Routing.generate('api_get_newslist', vm.params)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil( vm.total.count / vm.params.limit );

                    if ( response.data ) {
                        response.data.forEach(function(news) {
                            news['url'] = Routing.generate('news_view', {id: news.id});

                            news.disciplines = news.disciplines.map(function (discipline) {
                                discipline['url'] = Routing.generate('discipline_index', {url: discipline.url});

                                return discipline;
                            });

                            vm.data.push(news);
                        });
                    }

                    vm.submitted = false;
                    vm.loaded = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = false;
                });
            },
            next: function () {
                vm.params.offset += vm.params.limit;

                vm.submit( true );
            }
        };

        return vm;
    });
